function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#262C37",
  strokeDasharray: "4,4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  opacity: 0.25,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M484.082 21h-40.496L429.203 9 401 35h8v38h83V35h8l-15.918-14z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M467 44h13v13h-13V44zm-23 0h13v13h-13V44zm-23 0h13v13h-13V44zm-12-9h83m-90.157 32h97.942"
}));

function SvgSeparate5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 81
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MDAiIGhlaWdodD0iODEiIHZpZXdCb3g9IjAgMCA5MDAgODEiPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBzdHJva2U9IiMyNjJDMzciIHN0cm9rZS1kYXNoYXJyYXk9IjQsNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIG9wYWNpdHk9Ii4yNSI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik00ODQuMDgyIDIxaC00MC40OTZMNDI5LjIwMyA5IDQwMSAzNWg4djM4aDgzVjM1aDhsLTE1LjkxOC0xNHoiLz4KICAgICAgICAgICAgPHBhdGggZD0iTTQ2NyA0NGgxM3YxM2gtMTNWNDR6TTQ0NCA0NGgxM3YxM2gtMTNWNDR6TTQyMSA0NGgxM3YxM2gtMTNWNDR6TTQwOSAzNWg4M000MDEuODQzIDY3aDk3Ljk0MiIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgSeparate5 as ReactComponent };